export enum StatsLvl {
    Bronze = 'bronze',
    Silver = 'silver',
    Gold = 'gold',
    Vip = 'vip'
}
